import { lazy } from 'react';

import { Balance } from '@mui/icons-material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { EntitlementRouteWrapper } from '~/src/app/components/EntitlementRouteWrapper';
import { NavigationMenuCategory } from '~/src/app/components/Layout/components/NavigationMenu';
import { useUserEntitlements } from '~/src/hooks/useUserEntitlements';

const ReconciliationSessions = lazy(() => import('./pages/Sessions'));
const ReconciliationSession = lazy(() => import('./pages/Session'));
const ReconciliationSessionReview = lazy(() => import('./pages/SessionReview'));

export const ReconciliationRoutes = () => {
  const {
    entitlements: { isStaff },
    loading,
  } = useUserEntitlements();

  return (
    <EntitlementRouteWrapper isAccessible={isStaff} loading={loading}>
      <Routes>
        <Route element={<ReconciliationSessions />} path="sessions" />
        <Route element={<ReconciliationSession />} path="sessions/:sessionId" />
        <Route element={<ReconciliationSessionReview />} path="sessions/:sessionId/review" />
        <Route element={<Navigate to="sessions" />} path="*" />
      </Routes>
    </EntitlementRouteWrapper>
  );
};

export const reconciliationNavigationCategory: NavigationMenuCategory = {
  icon: <Balance color="secondary" />,
  items: [
    {
      name: 'reconciliation.items.sessions',
      route: '/reconciliation/sessions',
    },
  ],
  name: 'reconciliation.title',
};
